module.exports = __webpack_public_path__ + "img/alipay.3c3e5dc6.png";